import { configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import navigationReducer, { initialState as navInitialState } from './reducers/navigationSlice';
import templateReducer, { initialState as templateInitialState } from './reducers/templateSlice';
import collectionReducer from './reducers/collectionSlice';
import { customMiddleware } from './middleware/customMiddleware';
import authReducer from './reducers/authSlice';
import premiumReducer from './reducers/premiumSlice';

const initStore = () => {
   return configureStore({
      reducer: {
         navigation: navigationReducer,
         template: templateReducer,
         collection: collectionReducer,
         auth: authReducer,
         premium: premiumReducer
      },
      middleware: getDefaultMiddleware => getDefaultMiddleware().concat(customMiddleware),
      devTools: true
   });
};

export const wrapper = createWrapper(initStore);
